import { setUiFooter, setAuthView as setAV } from './config.slice';
import { useDispatch, useSelector } from 'react-redux';

export default function useConfig() {
  const dispatch = useDispatch();

  const showPromotionForm = useSelector(
    (state) => state.config.showPromotionForm,
  );
  const uiFooter = useSelector((state) => state.config.ui.footer);
  const authView = useSelector((state) => state.config.authView);

  const setFooter = (footer) => {
    dispatch(setUiFooter(footer));
  };

  const setAuthView = (view) => {
    dispatch(setAV(view));
  };

  return {
    showPromotionForm,
    uiFooter,
    setFooter,
    authView,
    setAuthView,
  };
}
